import { gql } from '@apollo/client';

export const GET_MS_USER_DATA = gql`
  query GetMsUserData($companyMemberId: ID!) {
    msUserData(companyMemberId: $companyMemberId) {
      mail
    }
  }
`;
